/** Default map center — Vientiane */
export const DEFAULT_MAP_CENTER: [number, number] = [102.6331, 17.9757];
export const DEFAULT_MAP_ZOOM = 6;

/** Create a GeoJSON polygon approximating a circle (meters). */
export function createCirclePolygon(
  centerLng: number,
  centerLat: number,
  radiusMeters: number,
  points = 64,
): GeoJSON.Feature<GeoJSON.Polygon> {
  const coords: [number, number][] = [];
  const distanceX =
    radiusMeters / (111320 * Math.cos((centerLat * Math.PI) / 180));
  const distanceY = radiusMeters / 110540;

  for (let i = 0; i < points; i++) {
    const theta = (i / points) * (2 * Math.PI);
    coords.push([
      centerLng + distanceX * Math.cos(theta),
      centerLat + distanceY * Math.sin(theta),
    ]);
  }
  coords.push(coords[0]!);

  return {
    type: "Feature",
    properties: {},
    geometry: {
      type: "Polygon",
      coordinates: [coords],
    },
  };
}

export function branchHasCoordinates(
  lat: number | null | undefined,
  lng: number | null | undefined,
): lat is number {
  return lat != null && lng != null && !Number.isNaN(lat) && !Number.isNaN(lng);
}

export function computeMapBounds(
  points: Array<{ lng: number; lat: number }>,
): [[number, number], [number, number]] | null {
  if (points.length === 0) return null;
  let minLng = points[0]!.lng;
  let maxLng = points[0]!.lng;
  let minLat = points[0]!.lat;
  let maxLat = points[0]!.lat;
  for (const p of points) {
    minLng = Math.min(minLng, p.lng);
    maxLng = Math.max(maxLng, p.lng);
    minLat = Math.min(minLat, p.lat);
    maxLat = Math.max(maxLat, p.lat);
  }
  return [
    [minLng, minLat],
    [maxLng, maxLat],
  ];
}
